//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImportacaoSucessoTabela from './ImportacaoSucessoTabela';
import ImportacaoErroTabela from './ImportacaoErroTabela';

export default {
  name: 'ImportacaoFinalizadaDialog',
  props: {
    tableRowsFinalizado: {
      type: Array,
      default: [],
    },
    tableHeaderFinalizado: {
      type: Array,
      default: [],
    },
    tableRowsErros: {
      type: Array,
      default: [],
    },
    tableHeaderErros: {
      type: Array,
      default: [],
    },
  },
  components: {
    ImportacaoSucessoTabela,
    ImportacaoErroTabela,
  },
  methods: {
    closeDialog() {
      this.$emit('IMPORTACAO_FINALIZADA_DIALOG_CLOSE');
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/importacao/ImportacaoFinalizadaDialog.vue?vue&type=script&lang=js&